import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { ReserveStatus } from '@/features/reserve/models/reserve';

type ReserveStatusBadgeConfig = {
    label: string;
    severity: 'warn' | 'success' | 'info' | 'danger' | 'secondary';
};

const RESERVE_STATUS_CONFIG: Record<ReserveStatus, ReserveStatusBadgeConfig> = {
    [ReserveStatus.BOOKING]: { label: 'BOOKING', severity: 'warn' },
    [ReserveStatus.PAID]: { label: 'PAID', severity: 'success' },
    [ReserveStatus.SCAN]: { label: 'SCAN', severity: 'info' },
    [ReserveStatus.COMPLETE]: { label: 'COMPLETE', severity: 'success' },
    [ReserveStatus.CANCEL]: { label: 'CANCEL', severity: 'danger' },
    [ReserveStatus.TIMEOUT]: { label: 'TIMEOUT', severity: 'secondary' }
};

@Component({
    selector: 'app-reserve-status-badge',
    standalone: true,
    imports: [TagModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<p-tag [value]="config().label" [severity]="config().severity"></p-tag>`
})
export class ReserveStatusBadgeComponent {
    readonly status = input<ReserveStatus | null | undefined>(ReserveStatus.BOOKING);
    readonly config = computed(() => RESERVE_STATUS_CONFIG[this.status() ?? ReserveStatus.BOOKING]);
}
